import { render } from "./ProfileProjectAllocation.vue?vue&type=template&id=e57e4bb8&scoped=true"
import script from "./ProfileProjectAllocation.vue?vue&type=script&lang=js"
export * from "./ProfileProjectAllocation.vue?vue&type=script&lang=js"

import "./ProfileProjectAllocation.vue?vue&type=style&index=0&id=e57e4bb8&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e57e4bb8"]])

export default __exports__